const code = (items) => {
    return `<pre>${items.data.code}</pre>`
}

module.exports = code